module.exports = __webpack_public_path__ + "static/fonts/Fact-ExtraLightItalic.f6d2d7c.ttf";